module.exports = __webpack_public_path__ + "img/nav_qrcode_download.bcbc72aa.png";